// React
import {NavLink} from "react-router-dom";

// Стили
import "./style/header.scss";


export function Header() {
    return (
        <header>
            {/* Навигация */}
            <nav className="nav_box">
                {/* Основная навигация */}
                <NavLink to="./reviews" className="nav_text" id="index">
                    <i className="bi bi-caret-right-fill unic_color"/> Отзывы
                </NavLink>
                <NavLink to="./" className="nav_text unic_color" id="index">TVOK</NavLink>
                <NavLink to="./shop" className="nav_text" id="shop">
                    Заказать <i className="bi bi-caret-left-fill unic_color"/>
                </NavLink>
            </nav>
        </header>
    )
}
